import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Category} from "../../models/category.model";
import {CommonUtils} from "../../utils/common";
import {CategoryService} from "../../providers/category.service";
import {AppStateService} from "../../providers/app-state.service";

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html',
  styleUrls: ['./category-tree.component.scss'],
})
export class CategoryTreeComponent implements OnInit {
  @Input() categories: Map<number, Category[]>;
  @Input() level: number;
  @Input() vClientUUID: string;
  @Output() levelEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output() categoryEmitter: EventEmitter<Category> = new EventEmitter<Category>();
  @Output() removeEmitter: EventEmitter<Category> = new EventEmitter<Category>();
  name: string;


  constructor(private commonUtils: CommonUtils, private categoryService: CategoryService,
              private appStateService: AppStateService) {
  }

  ngOnInit() {
  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }


  getCategoriesLevel(level: any, parentRowIdx): Category[] {
    let cs = this.categories.get(level) as Category[];
    return cs.filter(e => e.parentRowIdx === parentRowIdx).filter(s => !s.setToDelete)
  }

  getCategoriesParent(categories: Category[], parentRowIdx): Category {
    return categories.filter(e => e.rowIdx === parentRowIdx)[0]
  }


  addCategory(ct: Category) {
    let category = new Category();
    category.level = ct.level + 1;
    category.parentUUID = ct.uuid;
    category.parentRowIdx = ct.rowIdx;
    category.parentName = ct.name;
    this.categoryEmitter.emit(category);
  }

  remove(ct: Category) {
    if (ct.uuid) {
      this.appStateService.updateIsBusySubject(true);
      this.categoryService.checkCategoryCanBeDeleted(this.vClientUUID, ct.uuid).subscribe(e => {
        if (e) {
          this.commonUtils.presentYesNoActionSheet('Czy chcesz usunąć daną kategorię oraz zapisane do niej podkategorie?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
            this.removeEmitter.emit(ct);
          }, () => {
          });
        } else {
          this.commonUtils.presentAlertToast('Nie można usunąć kategorii gdyż znajdują się artykuły do niej przypisane');
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas sprawdzania kategorii');
      })


    } else {
      this.commonUtils.presentYesNoActionSheet('Czy chcesz usunąć daną kategorię oraz zapisane do niej podkategorie?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.removeEmitter.emit(ct);
      }, () => {
      });
    }

  }

  changeName(ct: any, $event) {
    ct.name = $event.detail.value;
  }


  getParentIdxs(level: number) {
    let cs = this.categories?.get(level) as Category[];
    return cs?.filter(e => !e.setToDelete)
      .map(e => e.parentRowIdx)
      .filter(this.onlyUnique)
      .sort((a, b) => {
        return a - b
      });
  }

  getBreadCrumbs(level: number, parentIdx: any) {
    let str = [];
    for (let i = level - 1; i >= 0; i--) {
      let ct = this.categories.get(i);
      if (this.getCategoriesParent(ct, parentIdx)) {
        str.push(this.getCategoriesParent(ct, parentIdx).name)
        parentIdx = this.getCategoriesParent(ct, parentIdx).parentRowIdx
      }
    }
    return str.reverse()
  }
}
